import type {
    WebAppleLoginApiRequest,
    WebFacebookLoginApiRequest,
    WebGoogleLoginApiRequest,
    WebKlarnaLoginApiRequest,
    WebMemberTokenApiRequest,
    WebMemberTokenApiResponse,
    WebMemberTokenByMfaApiResponse,
} from 'tradera/state/services/types/webapi-auth-generated';
import {
    type FetchBaseQueryError,
    createApi,
} from '@reduxjs/toolkit/query/react';
import type { SerializedError } from '@reduxjs/toolkit';
import {
    type WebApiError,
    isomorphicWebApiBaseQuery,
} from 'tradera/state/services/utils/webapi-base-query';

type LoginResponse =
    | {
          data: WebMemberTokenApiResponse;
      }
    | {
          error: FetchBaseQueryError | SerializedError | WebApiError;
      };

export const getMemberId = (
    response: LoginResponse | WebMemberTokenByMfaApiResponse,
) => {
    if ('data' in response) {
        return response.data.memberId;
    }
    return 0;
};

export const loginApi = createApi({
    reducerPath: 'loginApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        login: builder.mutation<
            WebMemberTokenApiResponse,
            WebMemberTokenApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/auth/web/member/token',
                method: 'POST',
                body: params,
            }),
        }),
        loginWithGoogle: builder.mutation<
            WebMemberTokenApiResponse,
            WebGoogleLoginApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/auth/web/member/login/google',
                method: 'POST',
                body: params,
            }),
        }),
        loginWithKlarna: builder.mutation<
            WebMemberTokenApiResponse,
            WebKlarnaLoginApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/auth/web/member/login/klarna',
                method: 'POST',
                body: params,
            }),
        }),
        loginWithFacebook: builder.mutation<
            WebMemberTokenApiResponse,
            WebFacebookLoginApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/auth/web/member/login/facebook',
                method: 'POST',
                body: params,
            }),
        }),
        loginWithApple: builder.mutation<
            WebMemberTokenApiResponse,
            WebAppleLoginApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/auth/web/member/login/apple',
                method: 'POST',
                body: params,
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useLoginWithAppleMutation,
    useLoginWithFacebookMutation,
    useLoginWithGoogleMutation,
    useLoginWithKlarnaMutation,
} = loginApi;
